import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Table, Button, OverlayTrigger, Popover } from 'react-bootstrap';

import OverviewField from './OverviewField'

import { deleteProject, getClientProposals, clearClientProposals } from '../../projects/reducers/manageProjects'

class ProjectOverview extends Component {
  state = {
    client: null
  }

  componentDidMount() {
    const client = this.props.clients.find(c => c.url === this.props.project.client)

    this.setState({ client })

    this.props.getClientProposals(client.id)
  }

  componentWillUnmount() {
    this.props.clearClientProposals()
  }

  checkUserName = (person) => {
    const { first_name, last_name } = this.props.currentUser
    const currentUserName = `${first_name} ${last_name}`
    const personName = `${person.first_name} ${person.last_name}`
    const isCurrentUser = currentUserName === personName
    return (
      <span
        key={person.id}
        className={isCurrentUser ? "current-user" : null}
      >
       {personName}&nbsp;&nbsp;&nbsp;
      </span>
    )
  }

  formatDate = (date) => {
    // PUTS THE DATE IN A MM/DD/YYYY FORMAT IF THE DATE EXISTS
    if (date) {
      const splitDate = date.split('-')
      return `${splitDate[1]}-${splitDate[2]}-${splitDate[0]}`
    } else {
      return null
    }
  }


  mapMetadataFields = () => {
    const { project, metadata } = this.props

    return metadata.map(meta => {
      const values = project.metadata_values.filter(value => value.metadata === meta.url)

      let valuesToString

      if (meta.type.toLowerCase() === 'selectable options') {
        valuesToString = values.map(value => value.option).join(', ')
      } else if (meta.type.toLowerCase() === 'number') {
        valuesToString = values[0] ? values[0].number : ''
      } else if (meta.type.toLowerCase() === 'date') {
        valuesToString = values[0] ? this.formatDate(values[0].date) : null
      } else if (meta.type.toLowerCase() === 'user') {
        const metadataUsers = values.map(value => value.user)
        valuesToString = this.mapUserNames(metadataUsers)
      } else if (meta.type.toLowerCase() === 'text') {
        valuesToString = values[0] ? values[0].text : ''
      } else {
        return null
      }

      return (
        <tr key={meta.id}>
          <td className="title-field">
            {meta.name}
          </td>
          <td>
            <OverviewField
              dataType="metadata_values"
              project={project}
              metadataType={meta}
              metadataValues={project.metadata_values}
              array={values}
              text={valuesToString}
              editProject={this.props.editProject}
            />
          </td>
        </tr>
      )
    })
  }


  mapUserNames = (users) => {
    const { currentUser } = this.props
    return users.map((user, index) => {
      let fullName = `${user.first_name} ${user.last_name}`
      if (index !== users.length - 1) {
        fullName += ','
      }

      return (
        <span
          key={`${user.id}-${index}`}
          className={user.id === currentUser.pk ? "current-user" : null}
        >
          {fullName}&nbsp;&nbsp;
        </span>
      )
    })
  }

  renderProposalName = (proposal) => {
    if (this.state.client) {
      return `${this.state.client.short_code} ${proposal.number} - ${proposal.title}`
    } else {
      return `${proposal.number} - ${proposal.title}`
    }
  }

  renderProposalData = (proposal, index) => {
    const clientManager = this.props.users.find(user => user.url === proposal.client_manager)

    const proposalTitle = this.state.client ?
      `${this.state.client.short_code} ${proposal.number} - ${proposal.title}`
      :
      `${proposal.number} - ${proposal.title}`

    const isLast = this.props.project.proposals && this.props.project.proposals.length - 1 === index

    const proposalDataPopover = (
      <Popover
        id={proposalTitle}
        title={proposalTitle}
      >
      <strong>Client Manager: </strong>
        {clientManager ?
          `${clientManager.first_name} ${clientManager.last_name}`
          :
          'N/A'
        }
        <br/>
        <br/>
        <strong>FTE vs SOW: </strong>
        {proposal.fte_sow ?
          proposal.fte_sow
          :
          'N/A'
        }
      </Popover>
    )

    return (
      <Fragment key={proposal.id}>
        <OverlayTrigger
          rootClose
          trigger={["click", "hover"]}
          placement="top"
          overlay={proposalDataPopover}
        >
          <span>
            {proposalTitle}
          </span>
        </OverlayTrigger>
        {isLast ?
          null
          :
          <Fragment>
            <br/>
            <br/>
          </Fragment>
        }
      </Fragment>
    )
  }


	render() {
    const { project, currentUser,  } = this.props
    let startDate = this.formatDate(project.start_date)
    let targetEndDate = this.formatDate(project.target_end_date)
    let completionDate = this.formatDate(project.completion_date)

    const projectLeadsToString = this.mapUserNames(project.project_leads)
    const analystsToString = this.mapUserNames(project.analysts)

    const deleteProjectPopover = (
      <Popover id="popover-positioned-right" title="Delete Project">
        Are you sure you want to delete the project:
        <br/>
        <br/>
        {project.title}?
        <br/>
        <br/>
        <span style={{fontWeight: 'bold', color: 'red'}}>
          This action cannot be undone.
        </span>
        <br/>
        <br/>
        <center>
          <Button
            bsStyle='danger'
            onClick={() => this.props.deleteProject(project) }
          >
            Delete
          </Button>
        </center>
      </Popover>
    )

    return (
      <div id="ProjectOverview">
        <Table>
          <tbody>

            {this.state.client ?
               <tr>
              <td className="title-field" style={{borderTop:"none"}}>
                Client
              </td>
              <td style={{borderTop:"none"}}>
                {this.state.client.name} {this.state.client.short_code}
              </td>
            </tr>
            :
            null
          }

            <tr>
              <td className="title-field">
                Short ID
              </td>
              <td>
                {project.short_id}
              </td>
            </tr>

            <tr>
              <td className="title-field">
                Number
              </td>
              <td>
                {project.number}
              </td>
            </tr>

            <tr>
              <td className="title-field">
                Project Title
                </td>
              <td>
                <OverviewField
                  dataType="title"
                  project={project}
                  text={project.title}
                  editProject={this.props.editProject}
                />
              </td>
            </tr>

            <tr>
              <td className="title-field">
                Description
              </td>
              <td>
                <OverviewField
                  dataType="description"
                  project={project}
                  text={project.description}
                  editProject={this.props.editProject}
                />
              </td>
            </tr>

            <tr>
              <td className="title-field">
                Status
              </td>
              <td>
                <OverviewField
                  dataType="status"
                  project={project}
                  text={project.status}
                  editProject={this.props.editProject}
                />
              </td>
            </tr>

            <tr>
              <td className="title-field">
                Regulatory Related
              </td>
              <td>
                <OverviewField
                  dataType="regulatory_related"
                  project={project}
                  text={project.regulatory_related}
                  editProject={this.props.editProject}
                />
              </td>
            </tr>

            <tr>
              <td className="title-field">
                Budgeted Hours
              </td>
              <td>
                <OverviewField
                  dataType="budgeted_hours"
                  project={project}
                  text={project.budgeted_hours}
                  editProject={this.props.editProject}
                />
              </td>
            </tr>

            <tr>
              <td className="title-field">
                Start Date
              </td>
              <td>
                <OverviewField
                  dataType="start_date"
                  project={project}
                  text={startDate}
                  editProject={this.props.editProject}
                />
              </td>
            </tr>

            <tr>
              <td className="title-field">
                Target End Date
              </td>
              <td>
                <OverviewField
                  dataType="target_end_date"
                  project={project}
                  text={targetEndDate}
                  editProject={this.props.editProject}
                />
              </td>
            </tr>

            <tr>
              <td className="title-field">
                Completion Date
              </td>
              <td>
                <OverviewField
                  dataType="completion_date"
                  project={project}
                  text={completionDate}
                  editProject={this.props.editProject}
                />
              </td>
            </tr>
            <tr>
              <td className="title-field">
                Project Lead(s)
              </td>
              <td>
                <OverviewField
                  dataType="project_leads"
                  project={project}
                  text={projectLeadsToString}
                  array={project.project_leads}
                  editProject={this.props.editProject}
                />
              </td>
            </tr>

            <tr>
              <td className="title-field">
                Analyst(s)
              </td>
              <td>
                <OverviewField
                  dataType="analysts"
                  project={project}
                  text={analystsToString}
                  array={project.analysts}
                  editProject={this.props.editProject}
                />
              </td>
            </tr>

            {this.mapMetadataFields()}

            {/*<tr>*/}
            {/*  <td className="title-field">*/}
            {/*    Proposal(s)*/}
            {/*  </td>*/}
            {/*  <td>*/}
            {/*    <OverviewField*/}
            {/*      dataType="proposals"*/}
            {/*      project={project}*/}
            {/*      array={project.proposals}*/}
            {/*      renderProposalName={this.renderProposalName}*/}
            {/*      text={project.proposals.map((proposal, index) => this.renderProposalData(proposal, index))}*/}
            {/*      editProject={this.props.editProject}*/}
            {/*    />*/}
            {/*  </td>*/}
            {/*</tr>*/}

            <tr>
              <td className="title-field">
                Revenue Dashboard Unique Identifier (RD_UID)
                </td>
              <td>
                <OverviewField
                  dataType="rduid"
                  project={project}
                  text={project.rduid}
                  editProject={this.props.editProject}
                />
              </td>
            </tr>

            <tr>
              <td className="title-field">
                File Directory (location of code on server)
              </td>
              <td>
                <OverviewField
                  dataType="directory"
                  project={project}
                  text={project.directory}
                  editProject={this.props.editProject}
                />
              </td>
            </tr>

            <tr>
              <td className="title-field">
                Created By
              </td>
              <td>
                {project.created_by && project.created_by.first_name ?
                  `${project.created_by.first_name} ${project.created_by.last_name}`
                  :
                  'N/A'
                }
              </td>
            </tr>

          </tbody>
        </Table>
        {currentUser.is_manager ?
          <OverlayTrigger
            rootClose
            trigger="click"
            placement="top"
            overlay={deleteProjectPopover}
          >
            <Button bsStyle="danger">
              Delete Project
            </Button>
          </OverlayTrigger>
          :
          null
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    users: state.manageLogin.users,
    currentUser: state.manageLogin.user,
    clients: state.manageLogin.clients,
    clientProposals: state.manageProjects.clientProposals,
  }
}

export default connect(mapStateToProps, { deleteProject, getClientProposals, clearClientProposals })(ProjectOverview)



// WEBPACK FOOTER //
// ./src/routes/projects_project/components/ProjectOverview.js